<template>
   <div class="layout layout-profile">
      <ProfileHero />
      <ProfileNav>
         <template v-if="route.name == 'profile-classes'" v-slot:actions>
            <Btn
               :text="{ do: 'Create Class' }"
               class="green"
               action
               @handle-action="toggleCreateClassModal"
            >
               <IconCirclePlusFilled />
            </Btn>
         </template>
      </ProfileNav>
      <div class="profile-wrapper">
         <NuxtPage />
      </div>

      <ModalsCreateClassModal
         :open="openCreateClassModal"
         @close="toggleCreateClassModal"
      />
   </div>
</template>
<script setup lang="ts">
import IconCirclePlusFilled from "~/assets/images/icons/circle-plus-filled.svg?component";
const { getProfileMeta, clearProfile } = useProfile();
const route = useRoute();

// REFS ========================
const openCreateClassModal = ref<boolean>(false);

await useAsyncData("profile-meta", () => getProfileMeta());

// METHODS ================
const toggleCreateClassModal = () => {
   openCreateClassModal.value = !openCreateClassModal.value;
};

// LIFECYCLE ================
onBeforeUnmount(() => {
   clearProfile();
});
</script>

<style lang="scss">
div.layout-profile {
   div.profile-nav {
      position: sticky;
      top: -1px;
   }
   div.profile-wrapper {
      min-height: 200px;
   }
}
</style>
